export type PurchaseResult = 'purchased' | 'cancelled' | 'unavailable' | 'failed';

export interface StoreProduct {
  id: string;
  title: string;
  description: string;
  priceLabel: string;
  kind: 'non-consumable';
}

export interface IapProvider {
  initialize(): Promise<void>;
  getProducts(): Promise<StoreProduct[]>;
  purchase(productId: string): Promise<PurchaseResult>;
  restore(): Promise<string[]>;
}

export class NoopIapProvider implements IapProvider {
  initialize(): Promise<void> {
    return Promise.resolve();
  }

  getProducts(): Promise<StoreProduct[]> {
    return Promise.resolve([]);
  }

  purchase(_productId: string): Promise<PurchaseResult> {
    return Promise.resolve('unavailable');
  }

  restore(): Promise<string[]> {
    return Promise.resolve([]);
  }
}

let iapProvider: IapProvider = new NoopIapProvider();

export function getIap(): IapProvider {
  return iapProvider;
}

export function configureIap(provider: IapProvider): void {
  iapProvider = provider;
}
